/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './devices-dashboard.scss';

/* eslint-disable import/no-unresolved, import/default */

import devicesDashboardTemplate from './devices-dashboard.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.farmer.devicesDashboard', [])
    .directive('devicesDashboard', DevicesDashboard)
    .name;

/*@ngInject*/
function DevicesDashboard() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '=',
            onDeviceSelected: '&'
        },
        controller: DevicesDashboardController,
        controllerAs: 'vm',
        templateUrl: devicesDashboardTemplate
    };
}

/* eslint-disable angular/angularelement */

/*@ngInject*/
function DevicesDashboardController($scope, $mdMedia, agTypes, agUtils, userService, agDeviceService) {

    let vm = this;
    vm.showData = userService.getAuthority() === 'TENANT_ADMIN' || userService.getAuthority() === 'CUSTOMER_USER';

    vm.devices = [];
    vm.currentDevice = null;

    vm.onWidgetClick = onWidgetClick;

    $scope.$watch(() => { return $mdMedia('gt-xs'); },(isGtXs) => {
        vm.isGtXs = isGtXs;
    });

    $scope.$watch(() => { return $mdMedia('gt-md'); }, (isGtMd) => {
        vm.isGtMd = isGtMd;
    });

    $scope.$watch('vm.ctx', () => {
        if (vm.showData && vm.ctx) {
            reloadDevices();
        }
    });

    $scope.$on('reloadFarmerDevices', () => {
        reloadDevices();
    });

    function reloadDevices(keepSelection) {
        vm.devices = [];
        if (!keepSelection) {
            vm.currentDevice = null;
        }
        vm.devicePromise = agDeviceService.getDevicesByType().then(
            (devices) => {
                vm.devices = filterFarmerDevices(devices);
                vm.devicePromise = null;
            },
            () => {
                vm.devices = [];
                vm.devicePromise = null;
            }
        );

    }

    function onWidgetClick($event, device) {
        if ($event) {
            $event.stopPropagation();
        }
        if (vm.currentDevice != device) {
            vm.currentDevice = device;
        }
        if (vm.onDeviceSelected) {
            vm.onDeviceSelected({device: device});
        }
    }

    function filterFarmerDevices(devices) {
        return devices.filter((device) => {
            return device.type === agTypes.farmerDeviceTypes.cellularSensorSpear.value || agUtils.ifMoistureDevice(device.type);
        });
    }

}